import {Component, Input, OnInit} from '@angular/core';
import {TransportIntervention, TransportInterventionPoi, TransportInterventionPoiGroupReport} from 'shared';

@Component({
  selector: 'app-transport-interventions-metrics',
  templateUrl: './transport-interventions-metrics.component.html',
  styleUrls: ['./transport-interventions-metrics.component.scss']
})
export class TransportInterventionsMetricsComponent implements OnInit {

  @Input()
  intervention: TransportIntervention;

  @Input()
  poiList: TransportInterventionPoi[];

  @Input()
  poiListGroupReport: TransportInterventionPoiGroupReport[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
